import { useGuttagekonto } from '@/domain/mitarbeiter/features/guttagekonto/hooks/useGuttagekonto';
import { DateNavigator } from '@e2n/ui/v2';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export function YearSwitch() {
  const { id } = useParams();
  const currentYear = dayjs().year();
  const { guttagekonto } = useGuttagekonto([id ?? ''], currentYear);

  const [displayedYear, setDisplayedYear] = useState<Date>(
    dayjs(String(guttagekonto.jahr), 'YYYY').toDate(),
  );

  const handleYearChange = (value: Date) => {
    if (value) {
      setDisplayedYear(dayjs(String(value), 'YYYY').toDate());
    }
  };

  return (
    <>
      <DateNavigator
        granularity="year"
        onChange={handleYearChange}
        onGrey={false}
        value={displayedYear}
      />
    </>
  );
}
